import React from "react";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";

function LegalPageLayout({ title, lastUpdated, children }) {
	const sectionsRef = useIntersectionObserver(
		(target) => target.classList.add("visible"),
		{ threshold: 0.1 },
	);

	return (
		<section className="legalPageContainer">
			<div
				ref={(el) => (sectionsRef.current[0] = el)}
				className="legalPageHeader animate"
			>
				<h1 className="legalPageTitle">{title}</h1>
				<p className="legalPageUpdated">Last updated {lastUpdated}</p>
			</div>

			<div
				ref={(el) => (sectionsRef.current[1] = el)}
				className="legalPageBody animate"
			>
				{children}
			</div>
		</section>
	);
}

export default LegalPageLayout;
